import {
    gridPageCountSelector,
    gridPageSelector,
    gridRowCountSelector,
    gridPageSizeSelector,
    useGridApiContext,
    useGridSelector
} from '@mui/x-data-grid';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import paginationStyle from '../../Styles/ComponentStyles/CustomPagination/CustomPagination.module.scss';

const CustomPagination = () => {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    const rowCount = useGridSelector(apiRef, gridRowCountSelector);
    const pageSize = useGridSelector(apiRef, gridPageSizeSelector);

    const handlePageChange = (newPage: any) => {
        apiRef.current.setPage(newPage);
    };

    // Calculate the range of items being displayed
    const startItem = page * pageSize + 1;
    const endItem = Math.min((page + 1) * pageSize, rowCount);

    const renderPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 3;
        let startPage = Math.max(0, Math.min(page - 1, pageCount - maxVisiblePages));
        let endPage = Math.min(pageCount - 1, startPage + maxVisiblePages - 1);

        // Adjust start if we're near the end
        if (endPage - startPage < maxVisiblePages - 1) {
            startPage = Math.max(0, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <button
                    key={i}
                    onClick={() => handlePageChange(i)}
                    className={`${paginationStyle.paginationNumber} ${page === i ? paginationStyle.active : ''}`}
                >
                    {i + 1}
                </button>
            );
        }

        return pages;
    };
    return (
        <div className={paginationStyle.customPagination}>
            <div className={paginationStyle.paginationInfo}>
                Showing {startItem}-{endItem} of {rowCount} profiles
            </div>
            <div className={paginationStyle.paginationControls}>
                <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 0}
                    className={paginationStyle.paginationNavButton}
                >
                    <span className={paginationStyle.prevText}>Previous</span>
                </button>

                <div className={paginationStyle.paginationNumbers}>
                    {renderPageNumbers()}
                </div>

                <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page >= pageCount - 1}
                    className={paginationStyle.paginationNavButton}
                >
                    <span className={paginationStyle.nextText}>Next</span>
                </button>
            </div>
        </div>
    );
};

export default CustomPagination;